import { hoursPerWeekModifier } from 'components/organisms/templates/projects/resource-management/managers/hours-per-week-modifier';
import { PhaseEntityType, converToEntityId } from 'data/projects/phase-entity';
import { floatUid } from 'utils/uid';
export const generateNewTaskRows = (data)=>{
    const phases = data.templateContent.projectPhases.map((phase, index)=>{
        var _phase_entityOrder, _phase_tasks;
        const task = {
            /**
       * floatUid at times returns same id when ran in loop,
       * hence adding index as patch fix to prevent duplicate ids.
       */ taskId: floatUid() + index,
            isNew: true,
            projectPhase: {
                projectPhaseId: phase.projectPhaseId
            },
            subTasks: [],
            startDay: phase.startDay || 1,
            duration: 1,
            private: phase.private
        };
        return {
            ...phase,
            entityOrder: [
                ...(_phase_entityOrder = phase.entityOrder) !== null && _phase_entityOrder !== void 0 ? _phase_entityOrder : [],
                converToEntityId(task.taskId, PhaseEntityType.Task)
            ],
            tasks: [
                ...(_phase_tasks = phase.tasks) !== null && _phase_tasks !== void 0 ? _phase_tasks : [],
                task
            ]
        };
    });
    return {
        ...data,
        templateContent: {
            ...data.templateContent,
            projectPhases: phases
        }
    };
};
export const hoursPerWeekModifierRedux = (data, isHoursPerWeek)=>{
    if (!isHoursPerWeek) {
        return data;
    }
    const { allocations } = data.templateContent;
    const modifiedTemplateAllocations = hoursPerWeekModifier(allocations !== null && allocations !== void 0 ? allocations : []);
    return {
        ...data,
        templateContent: {
            ...data.templateContent,
            allocations: modifiedTemplateAllocations
        }
    };
};
